// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a185ad10","455":"ee2998d1","977":"e42058b1"}[chunkId] + ".chunk.js";
};